import { FC, ReactElement } from 'react';
import { MuiPickersUtilsProvider, DatePicker as MuiDatePicker, DatePickerProps } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';

export const DatePicker: FC<DatePickerProps> = (props): ReactElement => (
  <MuiPickersUtilsProvider utils={DateFnsUtils}>
    <MuiDatePicker {...props} />
  </MuiPickersUtilsProvider>
);
